import * as Sentry from "@sentry/react-native";
import { useCallback } from "react";

export enum GoalType {
  AddPlayerToWatchlist,
  RemovePlayerFromWatchlist,
  ValidateCurrentUser,
  ConfirmSignIn,
  ResendOTP,
  UpdateProfile,
  SignIn,
  DeleteInvitation,
  ResendInvitation,
  LogIntoOrganization,
  UpdateOrganization,
  AcceptInvitation,
  RejectInvitation,
  DeactivateUser,
  ActivateUser,
  CreateInvitation,
  CreateOrganization,
  CreateOrganizationLeague,
  DeleteOrganizationLeague,
  CreateOrganizationTeam,
  DeleteOrganizationTeam,
  UpdateWatchlistPosition,
  UpdatePlayerPosition,
  DeleteWatchlist,
  UpdateWatchlist,
  CreateWatchlist,
  CreateNote,
  DeleteNote,
  DeactivateMe,
  RemovePlayerFromRecommendations,
  SignOut,
  OpenActivityDeepLink,
}

/**
 *
 */
interface Props {
  goalType: GoalType;
  value: string;
}

const useRecordUserGoal = ({ goalType, value }: Props) => {
  return useCallback(
    (overrides?: Props) => {
      // Set a tag to track player watchlist additions
      Sentry.setTag("user_goal", overrides?.goalType ?? goalType);

      // Add user context to identify who performed the action
      // Sentry.setUser({
      //   id: userId,
      //   username: "example_user",
      // });

      // Add a breadcrumb for the action
      Sentry.addBreadcrumb({
        category: "user-action",
        message: overrides?.value ?? value,
      });
    },
    [goalType, value]
  );
};

export default useRecordUserGoal;
